import React, { useContext } from 'react'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { sessionContext } from '@marketing-milk/frontend'
import { dynamicContext } from '../../context/DynamicContext'
import InputAdornment from '@material-ui/core/InputAdornment'
import { creativeContext } from '../../../../context/CreativeContext'

export function DynamicHeadline() {
  const { user } = useContext(sessionContext)
  const { creative } = useContext(creativeContext)
  const canEdit = !creative!.locked
  const { headlines, addHeadline, delHeadline, setHeadline } = useContext(dynamicContext)
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="w-100 d-flex">
            <Typography variant="h5" className="pt-2" data-testid="headline-tab">
              Headline
            </Typography>
            <Button
              className="ml-auto mr-0"
              color="secondary"
              variant="contained"
              disabled={headlines.length === 5}
              onClick={addHeadline}
            >
              <AddIcon className="mr-2" /> Add
            </Button>
          </div>
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {headlines.map((headline, i) => {
            const variation = i + 1
            const isDuplicate = headlines.filter(x => x === headline).length > 1
            return (
              <div className="mb-3" key={i}>
                <TextField
                  error={isDuplicate || !headline}
                  helperText={
                    (isDuplicate || !headline) && 'Field must be unique and cannot be empty'
                  }
                  id={`dynamic-headline-${variation}-input`}
                  label={`Headline ${variation}`}
                  fullWidth
                  placeholder="Enter headline text..."
                  value={headline}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          data-testid={`delete-icon-${variation}`}
                          edge="end"
                          aria-label="delete"
                          onClick={() => delHeadline(i)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={e => setHeadline(i, e.target.value)}
                  disabled={!canEdit}
                />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
